import { DocumentService } from './document.service';
import { Injectable } from '@angular/core';
import { AuthenticateService } from './authenticate.service';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { ProfissionalService } from './profissional.service';
import { ToastController } from '@ionic/angular';
import { environment } from '../environments/environment';
import { HOST_EHR } from '../util/constants';
import { RA } from 'src/models/sisreg';

export const STATUS_RA = {
    Solicitado: {
        label: 'Solicitada',
        cor: 'azulescuro'
    },
    Pendente: {
        label: 'Pendente',
        cor: 'amarelo'
    },
    Agendado: {
        label: 'Agendada',
        cor: 'azulescuro'
    },
    Recebido: {
        label: 'Recebida',
        cor: 'verde'
    },
    'Atendimento/Internado': {
        label: 'Realizada',
        cor: 'verde'
    },
    'Negado/Cancelado': {
        label: 'Negada / Cancelada',
        cor: 'vermelho'
    },
    Falta: {
        label: 'Não realizada',
        cor: 'vermelho'
    },
    'Em estado de erro': {
        label: 'Negada',
        cor: 'vermelho'
    },
    Confirmado: {
        label: 'Confirmada',
        cor: 'verde'
    },
    'Em espera': {
        label: 'Em espera',
        cor: 'amarelo'
    },
}

@Injectable({
    providedIn: 'root'
})
export class SisREGService {

    constructor(
        private http: HttpClient,
        private auth: AuthenticateService,
        private documentService: DocumentService,
        private profissionalService: ProfissionalService,
        private toastController: ToastController,
    ) {
    }

    async getList(): Promise<Array<RA>> {
        let jwtDecode: any = await this.auth.getDecodeToken();
        let datas = [];
        // let document: any = await this.getRead(`Composition?subject=Patient/${jwtDecode.cnsPaciente}&_include=Composition:subject&_sort=-date`);
        // datas = document.entry.map(async element => {
        //     if (element.resource.meta.profile[0].includes('BRRegulacaoAssistencial')) {
        //         let data = await this.get(element.fullUrl);
        //         return data;
        //     } else {
        //         let data = await this.get('');
        //         return data;
        //     }
        //     return false;
        // });
        // datas = await Promise.all(datas);
        return datas.filter(e => e);
    }


    async get(fullUrl: string) {
        let document: any = await this.getReadFull(`${fullUrl}/$document?`).catch(err => { });
        var datas = [];

        let result: RA = {
            procedimento: '-',
            idRNDS: '-',
            fullUrl: '-',
            status: '-',
            coCid: '-',
            modalidadeAmbulatorial: '-',
            especialidade: '-',
            motivoSolicitacao: '-',
            solicitacao: {
                data: '-',
                timestamp: null,
                coCnes: '-',
                nome: '-',
                endereco: '-',
                telefone: '-'
            }
        };
        if (document && document.entry) {
            if (document.entry) {
                await Promise.all(document.entry.map(async (element) => {
                    if (
                        element.resource.resourceType == "Composition" &&
                        element.resource.meta.profile[0].includes('BRRegulacaoAssistencial')
                    ) {
                        result.idRNDS = element.resource.id;
                    }
                }));
            }
        } else {
            //mock
            result = {
                procedimento: 'Endoscopia Digestiva Alta',
                idRNDS: '-',
                fullUrl: '-',
                status: 'Falta',
                coCid: '-',
                modalidadeAmbulatorial: 'Consulta médica em atenção primária',
                especialidade: '-',
                motivoSolicitacao: '-',
                solicitacao: {
                    data: '20/10/2023',
                    timestamp: moment('20/10/2023', 'DD/MM/YYYY').valueOf(),
                    coCnes: '-',
                    nome: 'UBS 6 de São Julião',
                    endereco: 'Quadra 6 lote 5 Setor Oeste - 72425000',
                    telefone: '3389-0989'
                },
                execucao: {
                    data: '20/10/2023',
                    timestamp: moment('20/10/2023', 'DD/MM/YYYY').valueOf(),
                    coCnes: '',
                    nome: 'UBS 6 do Gama',
                    endereco: 'Quadra 6 lote 5 Setor Oeste - 72425000',
                    telefone: '3389-0989'
                }
            };
        }
        return result;
    }

    async getRead(reference) {
        return this.http.get(
            HOST_EHR + '/api/fhir/r4/' + reference,
            { headers: await this.getHeadersContextText() }
        ).toPromise().then(data => {
            return data;
        }).catch(async (error) => {
            console.error(error);
            if (error.error && error.error.resourceType == "OperationOutcome" && !environment.production) {
                const toast = await this.toastController.create({
                    message: error.error.issue[0].diagnostics,
                    position: 'top',
                    duration: 4000,
                    cssClass: 'toast-error',
                });
                toast.present();
            }

            throw new Error(JSON.stringify(error));
        });
    }

    participanteResponsavel(participante) {
        let responsavel = false;
        participante.type.forEach(type => {
            type.coding.forEach(coding => {
                if (coding.system.includes('BRResponsabilidadeParticipante') && coding.code == 'atendimento') {
                    responsavel = true;
                }
            })
        });
        return responsavel;
    }

    async getCodeSystem(coding, keySystem = null) {
        let valor: {
            code: string;
            display: string;
        } = { code: null, display: null };
        let busca;
        if (keySystem) {
            coding.forEach(cod => {
                if (cod.system.includes(keySystem)) {
                    busca = cod;
                }
            });
        } else {
            busca = coding[0];
        }
        valor.code = busca.code;
        const cable: any = await this.documentService.getReadSystem(busca);
        valor.display = '-';
        if (cable && cable.parameter) {
            valor.display = cable.parameter.find((data) => (data.name == 'display')).valueString;
        }
        return valor;
    }

    async getOrganizationInfo(cnes) {
        return this.http.get(HOST_EHR + '/api/fhir/r4/Organization/' + cnes,
            { headers: await this.getHeadersContextText() }).toPromise().then(data => {
                return data;
            }).catch((error) => {
                return [];
            });
    }

    getHeadersContextText() {
        let server = JSON.parse(localStorage.getItem('app_icp_token'));
        const httpOptions = {
            'Content-Type': 'application/json',
            //'X-Authorization-Origin': ORIGIN,
            //'X-Authorization-Audience': 'prosus.saude.gov.br',
            //'X-Authorization-Server': 'CN=RNDS:PROSUS,CN=AC-RESTRITA-RNDS,O=DATASUS,C=BR',
            'X-Authorization-Server': 'Bearer ' + server.access_token,
            'Authorization': 'Bearer ' + this.auth.getAuthorizationToken(),
        };

        return httpOptions;
    }

    async getReadFull(reference) {
        return this.http.get(reference, { headers: await this.getHeadersContextText() }).toPromise().then(data => {
            return data;
        }).catch(async (error) => {
            console.error(error);
            if (error.error && error.error.resourceType == "OperationOutcome" && !environment.production) {
                const toast = await this.toastController.create({
                    message: error.error.issue[0].diagnostics,
                    position: 'top',
                    duration: 4000,
                    cssClass: 'toast-error',
                });
                toast.present();
            }

            throw new Error(JSON.stringify(error));
        });
    }
}
